import { Component, Input } from '@angular/core';

@Component({
    selector: 'linesgrid',
    templateUrl: 'linesgrid.component.html',
    styleUrls: ['linesgrid.component.scss'],
})
export class LinesGridComponent {
    @Input() public dataLineList;
    @Input() public scroll = false;
}
